import styled from 'styled-components';

const Required = styled.span`
  font-size: 16px;
  color: ${props => (props.selected ? '#75d295' : '#f36d5b')};
`;

export default Required;
